type UserLike = {
  _id?: unknown;
  customerId?: unknown;
  id?: unknown;
} | null | undefined;

export const normalizeCustomerIdValue = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;
  const normalized = value.trim();
  return normalized || undefined;
};

export const resolveCustomerIdFromUserLike = (value: UserLike): string | undefined => {
  if (!value || typeof value !== "object") {
    return undefined;
  }
  return (
    normalizeCustomerIdValue(value._id) ||
    normalizeCustomerIdValue(value.customerId) ||
    normalizeCustomerIdValue(value.id)
  );
};

export const resolveCustomerIdFromPersistedUser = (): string | undefined => {
  const parseStored = (raw: string | null): string | undefined => {
    if (!raw) return undefined;
    try {
      const parsed = JSON.parse(raw) as UserLike;
      return resolveCustomerIdFromUserLike(parsed);
    } catch {
      return undefined;
    }
  };
  return (
    parseStored(localStorage.getItem("vle-user")) ||
    parseStored(sessionStorage.getItem("vle-user")) ||
    undefined
  );
};

export const resolveFixedPhoneCustomerId = (options: {
  explicitCustomerId?: unknown;
  user?: UserLike;
}): string | undefined => {
  return (
    normalizeCustomerIdValue(options.explicitCustomerId) ||
    resolveCustomerIdFromUserLike(options.user) ||
    resolveCustomerIdFromPersistedUser()
  );
};
